import type {
  CandidatePresentation,
  EmployerFeedback,
  Interview,
  SearchMandate,
} from '../types/search';

export const searchMandates: SearchMandate[] = [
  {
    id: 'mandate-1',
    reference: 'MND-2026-041',
    employerProfileId: 'emp-1',
    positionTitle: 'Chief Operating Officer',
    reportingLine: 'Chief Executive Officer',
    industry: 'Healthcare and Health Technology',
    location: 'Nashville, TN',
    workArrangement: 'onsite',
    compensationRange: { currency: 'USD', baseMin: 620000, baseMax: 760000, bonusTargetPct: 45, isEstimate: false },
    leadershipResponsibilities:
      'Operating accountability for the acute and ambulatory network, including the post-acquisition standardization programme and the ambulatory expansion.',
    requiredExperience:
      'Multi-site operating leadership within one health system, with evidenced delivery of an integration or standardization programme.',
    urgency: 'within_quarter',
    confidentialityLevel: 'public',
    reasonForHiring: 'transformation',
    isReplacementSearch: false,
    engagementType: 'retained_search',
    specificationDocumentName: 'COO-position-specification-v3.pdf',
    stage: 'shortlist',
    ownerRecruiterId: 'rec-1',
    opportunityId: 'opp-1',
    createdAt: '2026-08-04T10:00:00Z',
    updatedAt: '2026-08-31T14:20:00Z',
  },
  {
    id: 'mandate-2',
    reference: 'MND-2026-044',
    employerProfileId: 'emp-1',
    positionTitle: 'Chief Financial Officer',
    reportingLine: 'Chief Executive Officer',
    industry: 'Manufacturing and Industrial',
    location: 'Chicago, IL',
    workArrangement: 'hybrid',
    compensationRange: { currency: 'USD', baseMin: 520000, baseMax: 640000, bonusTargetPct: 50, isEstimate: false },
    leadershipResponsibilities:
      'Finance leadership through a modernization programme covering reporting quality, systems and the finance operating model.',
    requiredExperience: 'CFO or divisional finance leadership with evidenced finance transformation delivery.',
    urgency: 'immediate',
    confidentialityLevel: 'strictly_confidential',
    reasonForHiring: 'replacement',
    isReplacementSearch: true,
    replacementIncumbentStatus: 'not_yet_notified',
    engagementType: 'confidential_replacement',
    specificationDocumentName: 'CFO-confidential-specification-v2.pdf',
    stage: 'longlist',
    ownerRecruiterId: 'rec-1',
    opportunityId: 'opp-2',
    createdAt: '2026-08-12T09:15:00Z',
    updatedAt: '2026-08-30T11:00:00Z',
  },
  {
    id: 'mandate-3',
    reference: 'MND-2026-038',
    employerProfileId: 'emp-1',
    positionTitle: 'Chief Information Security Officer',
    reportingLine: 'Chief Risk Officer',
    industry: 'Cybersecurity',
    location: 'New York, NY',
    workArrangement: 'hybrid',
    compensationRange: { currency: 'USD', baseMin: 450000, baseMax: 540000, bonusTargetPct: 60, isEstimate: false },
    leadershipResponsibilities: 'Security strategy, regulatory engagement on operational resilience, and board risk reporting.',
    requiredExperience: 'Security leadership in a regulated financial institution with direct regulator engagement.',
    urgency: 'within_quarter',
    confidentialityLevel: 'public',
    reasonForHiring: 'newly_created',
    isReplacementSearch: false,
    engagementType: 'retained_search',
    stage: 'client_interviews',
    ownerRecruiterId: 'rec-2',
    opportunityId: 'opp-3',
    createdAt: '2026-08-01T08:30:00Z',
    updatedAt: '2026-08-29T16:45:00Z',
  },
  {
    id: 'mandate-4',
    reference: 'MND-2026-047',
    employerProfileId: 'emp-1',
    positionTitle: 'Non-Executive Director and Audit Committee Chair',
    reportingLine: 'Board Chair',
    industry: 'Technology, Data and Artificial Intelligence',
    location: 'Boston, MA',
    workArrangement: 'hybrid',
    compensationRange: { currency: 'USD', baseMin: 90000, baseMax: 130000, isEstimate: false },
    leadershipResponsibilities: 'Chair the Audit Committee through the strengthening of reporting and controls ahead of a listing.',
    requiredExperience: 'Audit committee financial expertise; current or prior audit committee chairmanship.',
    urgency: 'within_half_year',
    confidentialityLevel: 'strictly_confidential',
    reasonForHiring: 'newly_created',
    isReplacementSearch: false,
    engagementType: 'retained_search',
    stage: 'research_and_mapping',
    ownerRecruiterId: 'rec-2',
    opportunityId: 'opp-4',
    createdAt: '2026-08-18T13:00:00Z',
    updatedAt: '2026-08-30T10:30:00Z',
  },
  {
    id: 'mandate-5',
    reference: 'MND-2026-049',
    employerProfileId: 'emp-1',
    positionTitle: 'Chief Technology Officer',
    reportingLine: 'Chief Executive Officer',
    industry: 'Technology, Data and Artificial Intelligence',
    location: 'Austin, TX',
    workArrangement: 'hybrid',
    compensationRange: { currency: 'USD', baseMin: 480000, baseMax: 580000, bonusTargetPct: 40, isEstimate: false },
    leadershipResponsibilities: 'Consolidate three acquired platforms without a delivery pause; build the engineering leadership bench.',
    requiredExperience: 'Engineering leadership at comparable scale with evidenced post-acquisition consolidation.',
    urgency: 'within_quarter',
    confidentialityLevel: 'confidential',
    reasonForHiring: 'growth',
    isReplacementSearch: false,
    engagementType: 'retained_search',
    stage: 'longlist',
    ownerRecruiterId: 'rec-2',
    opportunityId: 'opp-5',
    createdAt: '2026-08-20T09:00:00Z',
    updatedAt: '2026-08-31T09:00:00Z',
  },
  {
    id: 'mandate-6',
    reference: 'MND-2026-051',
    employerProfileId: 'emp-1',
    positionTitle: 'Interim Chief Financial Officer',
    reportingLine: 'Chief Executive Officer',
    industry: 'Life Sciences and Pharmaceuticals',
    location: 'Cambridge, MA',
    workArrangement: 'hybrid',
    compensationRange: { currency: 'USD', isEstimate: false },
    leadershipResponsibilities: 'Hold finance leadership through a financing round and hand over to the permanent appointee.',
    requiredExperience: 'CFO experience in clinical-stage life sciences with prior interim discipline.',
    urgency: 'immediate',
    confidentialityLevel: 'confidential',
    reasonForHiring: 'replacement',
    isReplacementSearch: true,
    replacementIncumbentStatus: 'departed',
    engagementType: 'interim_appointment',
    stage: 'engaged',
    ownerRecruiterId: 'rec-3',
    opportunityId: 'opp-8',
    createdAt: '2026-08-28T15:00:00Z',
    updatedAt: '2026-08-31T12:00:00Z',
  },
  {
    id: 'mandate-7',
    reference: 'MND-2026-036',
    employerProfileId: 'emp-1',
    positionTitle: 'President, Defense Business Unit',
    reportingLine: 'Chief Executive Officer, parent corporation',
    industry: 'Aerospace and Defense',
    location: 'Washington, DC',
    workArrangement: 'onsite',
    compensationRange: { currency: 'USD', baseMin: 700000, baseMax: 850000, bonusTargetPct: 70, isEstimate: false },
    leadershipResponsibilities: 'Business unit profit and loss, capture strategy and the government-customer relationship.',
    requiredExperience: 'Defense business-unit P&L leadership with evidenced capture leadership.',
    urgency: 'within_half_year',
    confidentialityLevel: 'confidential',
    reasonForHiring: 'succession',
    isReplacementSearch: true,
    replacementIncumbentStatus: 'notified',
    engagementType: 'retained_search',
    stage: 'shortlist',
    ownerRecruiterId: 'rec-1',
    opportunityId: 'opp-9',
    createdAt: '2026-08-05T09:30:00Z',
    updatedAt: '2026-08-28T17:00:00Z',
  },
  {
    id: 'mandate-8',
    reference: 'MND-2026-042',
    employerProfileId: 'emp-1',
    positionTitle: 'Chief Development Officer, Renewables',
    reportingLine: 'Chief Executive Officer',
    industry: 'Energy and Infrastructure',
    location: 'Denver, CO',
    workArrangement: 'hybrid',
    compensationRange: { currency: 'USD', baseMin: 450000, baseMax: 550000, bonusTargetPct: 50, isEstimate: false },
    leadershipResponsibilities: 'Development pipeline through to notice to proceed, including interconnection and permitting.',
    requiredExperience: 'Utility-scale development leadership across United States ISO markets.',
    urgency: 'within_quarter',
    confidentialityLevel: 'public',
    reasonForHiring: 'growth',
    isReplacementSearch: false,
    engagementType: 'retained_search',
    stage: 'research_and_mapping',
    ownerRecruiterId: 'rec-3',
    opportunityId: 'opp-10',
    createdAt: '2026-08-15T11:00:00Z',
    updatedAt: '2026-08-30T15:30:00Z',
  },
];

/**
 * The ONLY bridge between a candidate and an employer. Employer-side views are
 * built from these records; a candidate with no authorized presentation has no
 * representation in employer state at all.
 */
export const candidatePresentations: CandidatePresentation[] = [
  {
    id: 'pres-1',
    mandateId: 'mandate-1',
    opportunityId: 'opp-1',
    candidateProfileId: 'cand-1',
    applicationId: 'app-1',
    employerProfileId: 'emp-1',
    status: 'presented',
    authorizationConsentId: 'consent-auth-1',
    employerNamedInRequest: '[Verified client organization name]',
    requestedAt: '2026-08-25T10:00:00Z',
    respondedAt: '2026-08-25T18:32:00Z',
    presentedAt: '2026-08-26T09:00:00Z',
    documentIdsShared: ['doc-1', 'doc-2'],
  },
  {
    id: 'pres-2',
    mandateId: 'mandate-3',
    opportunityId: 'opp-3',
    candidateProfileId: 'cand-5',
    applicationId: 'app-4',
    employerProfileId: 'emp-1',
    status: 'presented',
    authorizationConsentId: 'consent-auth-2',
    employerNamedInRequest: '[Verified client organization name]',
    requestedAt: '2026-08-20T09:00:00Z',
    respondedAt: '2026-08-20T14:10:00Z',
    presentedAt: '2026-08-21T08:30:00Z',
    documentIdsShared: ['doc-8'],
  },
  {
    id: 'pres-3',
    mandateId: 'mandate-2',
    opportunityId: 'opp-2',
    candidateProfileId: 'cand-2',
    applicationId: 'app-2',
    employerProfileId: 'emp-1',
    status: 'authorization_requested',
    disclosureRestrictionReason:
      'The client has instructed that its identity be withheld until a candidate reaches the shortlist stage, because the incumbent Chief Financial Officer remains in seat and has not been notified.',
    requestedAt: '2026-08-31T11:00:00Z',
    documentIdsShared: [],
  },
  {
    id: 'pres-4',
    mandateId: 'mandate-7',
    opportunityId: 'opp-9',
    candidateProfileId: 'cand-6',
    applicationId: 'app-6',
    employerProfileId: 'emp-1',
    status: 'declined_by_candidate',
    authorizationConsentId: 'consent-auth-4',
    employerNamedInRequest: '[Verified client organization name]',
    requestedAt: '2026-08-26T13:00:00Z',
    respondedAt: '2026-08-27T07:45:00Z',
    documentIdsShared: [],
  },
];

export const interviews: Interview[] = [
  {
    id: 'int-1',
    presentationId: 'pres-1',
    mandateId: 'mandate-1',
    candidateProfileId: 'cand-1',
    employerProfileId: 'emp-1',
    stageLabel: 'First client interview — Chief Executive Officer',
    format: 'in_person',
    status: 'scheduled',
    proposedSlots: ['2026-09-08T14:00:00Z', '2026-09-09T15:00:00Z', '2026-09-10T13:00:00Z'],
    confirmedSlot: '2026-09-09T15:00:00Z',
    location: '[Client office address — released to candidate on confirmation]',
    panel: ['Chief Executive Officer', 'Chief Human Resources Officer'],
    candidateBriefingNote:
      'Ninety minutes. Expect detailed discussion of the standardization programme and of how you handled clinical leadership resistance. A written briefing pack is available in your document centre.',
    createdAt: '2026-08-28T10:00:00Z',
  },
  {
    id: 'int-2',
    presentationId: 'pres-2',
    mandateId: 'mandate-3',
    candidateProfileId: 'cand-5',
    employerProfileId: 'emp-1',
    stageLabel: 'Board Risk Committee Chair conversation',
    format: 'video',
    status: 'availability_requested',
    proposedSlots: ['2026-09-11T16:00:00Z', '2026-09-12T14:00:00Z'],
    panel: ['Board Risk Committee Chair'],
    createdAt: '2026-08-31T09:00:00Z',
  },
];

export const employerFeedback: EmployerFeedback[] = [
  {
    id: 'fb-1',
    presentationId: 'pres-1',
    employerProfileId: 'emp-1',
    authorUserId: 'user-emp-1',
    submittedAt: '2026-08-28T16:20:00Z',
    recommendation: 'advance',
    strengths:
      'Directly relevant integration experience and a credible account of how clinical relationships were preserved through standardization. Answers were specific and measurable.',
    reservations:
      'Ambulatory expansion experience is thinner than the specification asks for. Worth probing in the second conversation.',
    fitAgainstSpecification: 4,
  },
  {
    id: 'fb-2',
    presentationId: 'pres-2',
    employerProfileId: 'emp-1',
    authorUserId: 'user-emp-1',
    submittedAt: '2026-08-29T11:05:00Z',
    recommendation: 'hold',
    strengths: 'Strong regulatory engagement record and a clear, quantified way of describing accepted exposure.',
    reservations:
      'Has not yet held the top security seat. The committee would want to understand the support structure required in the first year.',
    fitAgainstSpecification: 3,
  },
];
